<!--
 * @Author: your name
 * @Date: 2021-08-15 17:23:15
 * @LastEditTime: 2022-03-21 02:18:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/views/ClaimMaterial/UploadBank.vue
-->
<template>
  <div class="collect-agreement">
    <van-dialog
      v-model="show"
      title="《理赔个人信息收集及使用授权条款》"
      theme="round-button"
      confirm-button-text="我已知晓"
      confirm-button-color="#f1a705"
    >
      <div class="dialog-content">
        <div class="box">
          <p>理赔个人信息收集及使用授权条款</p>
          <p>重要提示:</p>
          <p>
            尊敬的客户，为了保障您们的权益，请在线下签署(或线上勾选)<b>《理赔个人信息收集及使用授权条款》</b>前，务必审慎阅读、充分理解本授权条款的内容(<b>特别是黑体字条款</b>)，关注您们在本授权条款中的权利、义务。
            如您们对下述授权条款有疑问，可在柚儿健康微信公众号进行留言咨询。
          </p>
        </div>
        <div class="box">
          <p>一、适用范围</p>
          <p>本授权条款适用干您们向我们申请理赔服务。</p>
        </div>
        <div class="box">
          <p>二、我们如何收集、加工和使用您们的个人信息</p>
          <p>
            (一)按照法律法规、规章及监管规定等要求。当您们向承保的保险公司申请办理理赔业务时，我们会向您们或我们委托的第三方合作机构及必要合作伙伴(以下简称“受托公司”)收集(检索、调阅、摘抄、复印或其他方式获取)、加工、使用您们的:姓名、性别、国籍、联系方式、有效身份证件的类型、号码和有效期限、出生日期、医疗健康信息(包括因医疗就诊产生的就诊信息、病历信息、处方医嘱信息、结算信息、票据信息、司法鉴定材料)、银行卡号、保单信息、保险事故信息。前述加黑加粗信息属于您们的敏感个人信息，为理赔环节必要性信息，如您们不同意提供该信息，可能无法使用我们提供的服务。如我们收集您们的个人信息涉及不满14周岁的未成年人个人信息，我们会将其个人信息按照相关法律法规及监管要求予以保护。我们会通过书面协议等方式要求受托公司遵守严格的保密义务及采取有效的保护措施禁止受托公司将我们向其提供的您们的个人信息用于未经您们授权的用途。在委托关系解除时，受托公司不再保存我们向其提供的您们的个人信息。
          </p>
          <p>
            (二)根据所适用的法律法规和监管要求，我们可能会对您的个人信息采取脱敏、去标识化等方式进行分析和使用，以便为您提供更加准确、流畅及便捷的服务，或帮助我们改进保险产品和服务。我们就此类处理后的信息不会重新识别个人，处理后的信息使用无需另行向您通知并征得您的同意。
          </p>
          <p>
            (三)根据相关法律、行政法规的规定，除了取得您们的同意的情形，我们还会在法律法规允许的范围内收集、加工和使用您们的个人信息，包括:
          </p>
          <p>1、与理赔业务需要履行法定职责或者法定义务所必需的;</p>
          <p>2、为签订和履行合同所必需的;</p>
          <p>
            3、为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需的;
          </p>
          <p>
            4、为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理您们的个人信息;
          </p>
          <p>
            5、在合理的范围内处理您们自行公开或者其他已经合法公开的您们的个人信息;
          </p>
          <p>6、法律、行政法规规定的其他情形。</p>
        </div>
        <div class="box">
          <p>三、我们如何传输、提供、委托处理、公开您们的个人信息</p>
          <p>(一)传输、对外提供、委托处理</p>
          <p>
            我们只在上述授权范围内处理个人信息，并最大限度地保护您的个人权益，超过上述授权范围我们会根据个人信息保护相关法律法规履行相关义务。
          </p>
          <p>
            我们不会在未经您们同意或授权的情况下向任何公司、组织和个人传输、提供、委托处理您们的个人信息，但是您们在此同意，我们可在以下情况下对外传输、提供、委托处理您们的个人信息:根据法律法规规定，或按政府主管部门的强制性要求。
          </p>
          <p>(二)公开</p>
          <p>
            原则上，柚儿健康不会公开披露您们的个人信息。如确需公开披露，柚儿健康会征得您们的明确同意。除此以外，在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会依法公开披露您们的个人信息。
          </p>
        </div>
        <div class="box">
          <p>四、我们如何存储和保护您们的个人信息</p>
          <p>
            (一)我们已使用符合业界标准的安全防护措施存储和保护您们提供的个人信息，防止您们提供给我们的个人信息遭到未经授权访问以及个人信息泄露、算改、丢失。我们会采取一切合理可行的措施，保护您们的个人信息。我们仅在上述信息处理目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。
          </p>
          <p>
            (二)我们将针对处理敏感个人信息，利用个人信息进行自动化决策，委托处理个人信息、向其他个人信息处理者提供个人信息、公开个人信息向境外提供个人信息等对您们的个人权益可能有重大影响的个人信息处理活动，就处理目的、处理方式等是否合法、正当、必要，对个人权益的影响及安全风险，所采取的保护措施是否合法、有效并与风险程度相适应等事项，开展事前个人信息保护影响评估，并将评估报告和处理情况记录予以保存。
          </p>
          <p>必要的合作伙伴及第三方合作机构:</p>
          <p>本人郑重声明:</p>
          <p>
            1、本人声明在柚儿健康公众号平台理赔报案填写的本人信息及本人提供的一切资料均完全属实，如有虚假不实或隐瞒情况，本人愿意承担由此产生的一切法律后果。
          </p>
          <p>
            2、本人同意并授权柚儿健康公众号平台及所属公司（北京医帆心安科技有限公司）可自行或通过委托第三方机构向任何单位或个人查询、收集与本次理陪申请有关的资料(包括证件号码、保单信息、银行账号、病历、票据信息、结算信息、司法签定材料及履行理赔服务所必需的资料)，用于本人理赔服务。
          </p>
          <p>
            3、如需银行转账，本人声明授权承保的保险公司将赔偿金直接划入受益人提供的银行账户。
          </p>
          <p>
            4、本人同意柚儿健康公众号平台及承保公司，除法律另有规定之外，将本人、投保人及投保人委托的中介机构提供给承保公司的信息、享受承保公司服务产生的信息(包括本单证签署之前提供和产生的)以及承保公司根据本条约定查询、收集的信息，向承保公司因服务必要开展合作的相关方提供，并用于承保公司及上述相关方为本人提供必要的服务与理赔数据分析等。
          </p>
          <p>
            5、<b
              >本人承诺本次提供用于理赔报案的所有医疗单据，不再用于其他理赔报销使用，一经发现，本人愿意承担由此产生的一切法律后果。</b
            >
          </p>
          <p>
            为确保本人信息的安全，柚儿健康公众号平台及承保公司对上述信息负有保密义务，并采取各种措施保证信息安全。
          </p>
          <p>
            本条款自本单证签署时生效，具有独立法律效力，不受合同成立与否及效力状态变化的影响。
          </p>
          <p>
            如您不同意上述慢权条款的部分或全部，可咨询柚儿健康公众号平台取消或变更降权
          </p>
          <p>*申请人签字:</p>
          <p>*签字日期:</p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: "UserAgreement",
  data() {
    return {
      show: false,
    };
  },
};
</script>
<style scoped lang="less">
.dialog-content {
  margin: 8px;
  padding: 6px;
  height: 68vh;
  overflow-y: auto;
}
.collect-agreement {
  .box {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 28px;
  }
}
</style>
